import { SalvSwitch } from '@salvapp/ui-components';
import React from 'react';
import './ListSelector.scss';

interface Props {
  title: string;
  isSelected: boolean;
  onChange: (isToggled: boolean) => void;
}

export const ListSelector = ({ title, isSelected, onChange }: Props) => {
  return (
    <div className='list-selector m-t-8'>
      <div className='switch'>
        <div className='title-s'>{title}</div>
        <SalvSwitch ariaLabel={title} selected={isSelected} onChange={onChange} />
      </div>
    </div>
  );
};
